import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const TextLinkWrapped = styled.h5`
  margin: 0;
  font-family: 'Montserrat-Medium', sans-serif;
  text-decoration: underline;
  cursor: pointer;
  color: ${({ color }) => (color ? color : theme.colors.blue900)};

  ${theme.breakpoints.down('md')} {
    margin-top: ${theme.variables.spacer * 1}px 0;
    font-size: 12px;
  }
`
